import { render, staticRenderFns } from "./DiscardChange.vue?vue&type=template&id=2aefabd1&scoped=true&"
import script from "./DiscardChange.vue?vue&type=script&lang=js&"
export * from "./DiscardChange.vue?vue&type=script&lang=js&"
import style0 from "./DiscardChange.vue?vue&type=style&index=0&id=2aefabd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aefabd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDialog})
